module.exports = __webpack_public_path__ + "static/media/brand-three-dot.6f6be44e.svg";